import { useNewBookingStore } from '../../../../domain/booking/stores/useNewBookingsStore';

export interface IExtrasPageLinkWithFallbackProps {
	extrasTitle: string;
	extrasUrl: string;
	fallbackTitle: string;
	fallbackUrl: string;
}

export interface IPageLink {
	title: string;
	url: string;
}

export function useExtrasPageLinkWithFallback({
	extrasTitle,
	extrasUrl,
	fallbackTitle,
	fallbackUrl,
}: IExtrasPageLinkWithFallbackProps): IPageLink {
	const { parkingProductsQuoteStore } = useNewBookingStore();
	const hasExtrasPages =
		parkingProductsQuoteStore.hasUpgrades ||
		parkingProductsQuoteStore.hasAncillaries;

	return hasExtrasPages
		? {
				title: extrasTitle,
				url: extrasUrl,
		  }
		: {
				title: fallbackTitle,
				url: fallbackUrl,
		  };
}
